"use strict";
var ArrayObservable_1 = require('./ArrayObservable');
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/of.js
// module id = ./node_modules/rxjs/observable/of.js
// module chunks = vendor